import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import SelectConFiltro from "../../../../../components/select-con-filtro/SelectConFiltro"; // ajusta el path
import "./trading-rules.css";
import Swal from "sweetalert2";

function TradingRules() {
  const clientes = [
    "A.S. GLOBAL FORWARDING SA DE CV",
    "BLANES HERMANOS TRADE SA DE CV",
    "CAROLINA PERFORMANCE FABRICS SA DE CV",
    "COMERCIO Y NEGOCIOS TH",
    "KEMI KALS",
    "KLUMEXSA DE MEXICO",
    "RED ADUANAS ENVIOS Y COMERCIO SA DE CV",
    "SUMIPRINTMEX SA DE CV",
    "201 OFICIAL SA DE CV",
    "2k DESPACHOS ADUANALES SC",
  ];
  const usuarios = [
    "A.S. GLOBAL FORWARDING SA DE CV",
    "BLANES HERMANOS TRADE SA DE CV",
    "CAROLINA PERFORMANCE FABRICS SA DE CV",
    "COMERCIO Y NEGOCIOS TH",
    "KEMI KALS",
    "KLUMEXSA DE MEXICO",
    "RED ADUANAS ENVIOS Y COMERCIO SA DE CV",
    "SUMIPRINTMEX SA DE CV",
    "201 OFICIAL SA DE CV",
    "2k DESPACHOS ADUANALES SC",
  ];

  const [clienteSeleccionado, setClienteSeleccionado] = useState("");
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState("");
  const [copiedCheckStates, setCopiedCheckStates] = useState(null);
  const [copiedRowStates, setCopiedRowStates] = useState(null);
  const [copiedCantidadStates, setCopiedCantidadStates] = useState(null);

  const initialCheckStates = {
    manejoCarga: false,
    refrigeracion: false,
    congelacion: false,
    screening: false,
    dgFee: false,
    manejoValor: false,
    flejeEmpaque: false,
    cancelacionFactura: false,
    animalesVivos: false,
    dgExentas: false,
    hieloSeco: false,
  };

  const initialRowStates = Object.keys(initialCheckStates).reduce(
    (acc, key) => {
      acc[key] = { tipoExcepcion: "", moneda: "" };
      return acc;
    },
    {}
  );
  const [checkStates, setCheckStates] = useState(initialCheckStates);
  const [rowStates, setRowStates] = useState(initialRowStates);
  const [cantidadStates, setCantidadStates] = useState(
    Object.keys(initialCheckStates).reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {})
  );

  const handleCantidadChange = (key, value) => {
    // Solo acepta números con punto decimal
    if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
      setCantidadStates((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const rows = [
    { label: "Manejo de carga", key: "manejoCarga" },
    { label: "Refrigeración", key: "refrigeracion" },
    { label: "Congelación", key: "congelacion" },
    { label: "Screening", key: "screening" },
    { label: "DG Fee", key: "dgFee" },
    { label: "Manejo por valor", key: "manejoValor" },
    { label: "Fleje y empaque", key: "flejeEmpaque" },
    { label: "Cancelación de factura", key: "cancelacionFactura" },
    { label: "Animales vivos", key: "animalesVivos" },
    { label: "DG exentas", key: "dgExentas" },
    { label: "Hielo seco", key: "hieloSeco" },
  ];

  const handleCheckChange = (key) => {
    setCheckStates((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const renderSelect = (enabled, value, onChange, options = []) => (
    <select
      className="form-select"
      disabled={!enabled}
      value={value}
      onChange={onChange}
    >
      <option value="" disabled hidden={!enabled}>
        {enabled ? "Selecciona..." : ""}
      </option>
      {options.map((opt) => (
        <option key={opt.value || opt} value={opt.value || opt}>
          {opt.label || opt}
        </option>
      ))}
    </select>
  );

  const handleRowSelectChange = (key, field, value) => {
    setRowStates((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };

  const tipoExcepcionOptions = [
    { value: "opt1", label: "Descuento %" },
    { value: "opt2", label: "Tarifa fija" },
    { value: "opt3", label: "Descuento sobre tarifa" },
    { value: "opt4", label: "Cobro por pieza" },
  ];

  const monedaOptions = [
    { value: "MXN", label: "MXN" },
    { value: "USD", label: "USD" },
  ];

  const handleGuardar = () => {
    const datosGuardados = [];

    Object.keys(checkStates).forEach((key) => {
      if (checkStates[key]) {
        datosGuardados.push({
          concepto: key,
          tipoExcepcion: rowStates[key].tipoExcepcion,
          moneda: rowStates[key].moneda,
          cantidad: cantidadStates[key],
        });
      }
    });

    if (copiedCheckStates && copiedRowStates) {
      const datosCopiados = [];

      Object.keys(copiedCheckStates).forEach((key) => {
        if (copiedCheckStates[key]) {
          datosCopiados.push({
            concepto: key,
            tipoExcepcion: copiedRowStates[key].tipoExcepcion,
            moneda: copiedRowStates[key].moneda,
            cantidad: copiedCantidadStates?.[key] || "", // si ya hiciste copia de cantidades
          });
        }
      });

      console.log("Datos guardados del cliente actual:", datosGuardados);
      console.log("Datos guardados del cliente copiado:", datosCopiados);
    } else {
      console.log("Datos guardados del cliente actual:", datosGuardados);
    }

    Swal.fire({
      title: "Éxito",
      text: "Datos guardados con éxito",
      icon: "success",
      iconColor: "#1B9925",
      customClass: {
        confirmButton: "btn-ok",
        title: "alert-title",
        popup: "alert-bg",
      },
    });
  };

  const handleCopiarReglas = () => {
    const datosCopiados = [];

    Object.keys(checkStates).forEach((key) => {
      if (checkStates[key]) {
        datosCopiados.push({
          concepto: key,
          tipoExcepcion: rowStates[key].tipoExcepcion,
          moneda: rowStates[key].moneda,
          cantidad: cantidadStates[key],
        });
      }
    });

    if (usuarioSeleccionado && datosCopiados.length > 0) {
      setCopiedCheckStates({ ...checkStates });
      setCopiedRowStates({ ...rowStates });
      setCopiedCantidadStates({ ...cantidadStates });

      console.log("Datos copiados al usuario:", usuarioSeleccionado);
      console.log("Contenido:", datosCopiados);

      Swal.fire({
        title: "Éxito",
        text: "Los datos han sido copiados exitosamente",
        icon: "success",
        iconColor: "#1B9925",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
    } else {
      Swal.fire({
        title: "Error",
        text: "Selecciona un usuario destino y llena al menos una regla.",
        icon: "error",
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>Horus | Reglas Comerciales</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="row mb-3">
              <div className="col-md-6">
                <SelectConFiltro
                  label="Cliente"
                  options={clientes}
                  selected={clienteSeleccionado}
                  setSelected={setClienteSeleccionado}
                />
              </div>
              <div className="col-md-6">
                <SelectConFiltro
                  label="Copiar reglas a:"
                  options={usuarios}
                  selected={usuarioSeleccionado}
                  setSelected={setUsuarioSeleccionado}
                />
              </div>

              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" onClick={handleCopiarReglas}>
                  Copiar reglas
                </button>
              </div>
            </div>
          </div>

          {clienteSeleccionado && (
            <div className="col-md-12 mt-4">
              <table className="table fondo-headBilling">
                <thead>
                  <tr className="text-center">
                    <th>Concepto</th>
                    <th>Excepción</th>
                    <th>Tipo excepción</th>
                    <th>Cantidad</th>
                    <th>Moneda</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.key} className="align-middle">
                      <td>{row.label}</td>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={checkStates[row.key]}
                          onChange={() => handleCheckChange(row.key)}
                        />
                      </td>
                      <td>
                        {renderSelect(
                          checkStates[row.key],
                          rowStates[row.key].tipoExcepcion,
                          (e) =>
                            handleRowSelectChange(
                              row.key,
                              "tipoExcepcion",
                              e.target.value
                            ),
                          tipoExcepcionOptions
                        )}
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          disabled={!checkStates[row.key]}
                          inputMode="decimal"
                          value={cantidadStates[row.key]}
                          onChange={(e) =>
                            handleCantidadChange(row.key, e.target.value)
                          }
                        />
                      </td>
                      <td>
                        {row.key === "congelacion" ? (
                          <div className="row">
                            <div className="col-md-6">
                              {renderSelect(
                                checkStates[row.key],
                                rowStates[row.key].moneda,
                                (e) =>
                                  handleRowSelectChange(
                                    row.key,
                                    "moneda",
                                    e.target.value
                                  ),
                                monedaOptions
                              )}
                            </div>
                            <div className="col-md-6">
                              <div className="d-flex align-items-center gap-2">
                                <label
                                  htmlFor="precioTerceros"
                                  className="form-check-label"
                                >
                                  ¿Precio terceros?
                                </label>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="precioTerceros"
                                  disabled={!checkStates[row.key]}
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          renderSelect(
                            checkStates[row.key],
                            rowStates[row.key].moneda,
                            (e) =>
                              handleRowSelectChange(
                                row.key,
                                "moneda",
                                e.target.value
                              ),
                            monedaOptions
                          )
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {clienteSeleccionado && (
            <div className="btns mt-3 d-flex justify-content-end gap-3">
              <button className="btnn" onClick={handleGuardar}>
                Guardar
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TradingRules;
